import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const StaticTextValue = ({ ruleId, staticText }) => (
  <Input
    fluid
    readOnly
    value={staticText}
    input={{ 'data-testid': `static-text-input-${ruleId}` }}
  />
);

StaticTextValue.propTypes = {
  ruleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  staticText: PropTypes.string.isRequired,
};

export default StaticTextValue;
